import * as core from '../../../../../../../core'

import { query } from './ytd-revenue-by-org.query'

export const RESOURCE = {
  payload: {
    alias: 'ytd.revenue.by.org',
    description: 'Bar chart showing Year-to-Date revenue by organization',
    name: 'YTD Revenue by Organization',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
